{
  "(optional)": "(προαιρετικό)",
  "(required)": "(απαιτείται)"
}